import { useTranslation } from 'react-i18next';

import { BACKSPLASH_INPUT_LIMIT, WATERFALL_INPUT_LIMIT } from '../constants';
import { SideItemOption } from '../enums';
import { ArrowInfo } from '../models';

import { NotifierType, showNotification } from '~/legacy/components';

const sideItemLimits: Record<SideItemOption, { MIN: number; MAX: number }> = {
  [SideItemOption.WATERFALL]: WATERFALL_INPUT_LIMIT,
  [SideItemOption.BACKSPLASH]: BACKSPLASH_INPUT_LIMIT,
};

const notifySideItemError = (title: string, message: string) =>
  showNotification(NotifierType.WARNING, title, message);

export const useSideItemValidation = () => {
  const { t } = useTranslation();

  const sideItemTitles: Record<SideItemOption, string> = {
    [SideItemOption.WATERFALL]: t('WATERFALL.TITLE'),
    [SideItemOption.BACKSPLASH]: t('BACKSPLASH.TITLE'),
  };

  const validateHeightDimension = (
    prefix: string,
    value: number,
    limit: { MIN: number; MAX: number }
  ): string => {
    const conditions: [string, () => boolean][] = [
      ['WARNING_MAXIMUM', () => value > limit.MAX],
      ['WARNING_MINIMUM', () => value < limit.MIN],
      ['WARNING_ROUND', () => value % 0.25 !== 0],
    ];
    const [suffix] = conditions.find(([, match]) => match()) ?? [''];

    return suffix ? t(`${prefix}.${suffix}`, limit) : '';
  };

  const validateAndNotifySideItemHeightError = (
    type: SideItemOption,
    size: number
  ) => {
    const errorMessage = validateHeightDimension(
      type.toUpperCase(),
      size,
      sideItemLimits[type]
    );

    if (errorMessage) {
      notifySideItemError(sideItemTitles[type], errorMessage);
    }
  };

  const validateSideItemHeight = (
    arrow: ArrowInfo,
    sideItemSize?: string,
    sideItemType?: SideItemOption
  ) => {
    if (
      arrow.isSideItemPresent &&
      arrow.size !== undefined &&
      sideItemSize !== undefined &&
      sideItemType &&
      sideItemType in sideItemLimits
    ) {
      validateAndNotifySideItemHeightError(sideItemType, Number(sideItemSize));
    }
  };

  return {
    validateAndNotifySideItemHeightError,
    validateSideItemHeight,
  };
};
